/** @format */

export const featureFlagNames = [
    'BEAK-2867-(model-recommendations)',
    'BOO-3170-(sell-balance)',
    'LOVE-389-(new-checkout-buy)',
    'LOVE-389-(new-checkout-payment-link)',
    'LOVE-747-(enhanced-product-protection)',
    'BEAK-3098-(auto-out-of-stock-search)',
    'TUR-2946-(humanised-filters)',
    'BEAK-3676-(usp-tags)',
    'APE-2838-(self-serve-returns-phase-2)',
    'TUR-3230-(super-skus)',
    'LOVE-1153-(sell-journey-accessories-checklist)',
] as const;

export enum RecommendationsVariant {
    CONTROL = 'control',
    VARIANT = 'variant',
}
